import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useImpersonation } from '../../context/ImpersonationContext';

/**
 * באנר עליון שמוצג רק כאשר סופר-אדמין במצב impersonation.
 * העמותה לא רואה את הבאנר הזה — הוא מופיע אך ורק ב-session של הסופר-אדמין
 * (כי רק הוא טוען את ImpersonationContext עם מצב פעיל).
 */
const ImpersonationBanner: React.FC = () => {
  const { isImpersonating, orgName, allowWrite, setAllowWrite, stop } = useImpersonation();
  const navigate = useNavigate();

  if (!isImpersonating) return null;

  return (
    <div
      dir="rtl"
      className="w-full bg-gradient-to-l from-purple-700 to-indigo-700 text-white px-4 py-2 flex items-center justify-between gap-3 shadow-md sticky top-0 z-[9999]"
      role="status"
      aria-live="polite"
    >
      <div className="flex items-center gap-2 min-w-0">
        <span className="text-lg" aria-hidden>🕶️</span>
        <span className="text-sm font-semibold truncate">
          מצב צפייה: <span className="font-bold">{orgName || 'עמותה'}</span>
        </span>
        <span className="hidden sm:inline text-xs text-purple-200 mr-2">
          — העמותה לא רואה שאתה פה
        </span>
      </div>

      <div className="flex items-center gap-2 flex-shrink-0">
        <label className="flex items-center gap-1.5 text-xs cursor-pointer select-none">
          <input
            type="checkbox"
            checked={allowWrite}
            onChange={(e) => setAllowWrite(e.target.checked)}
            className="accent-white w-3.5 h-3.5"
          />
          <span>אפשר עריכה</span>
        </label>
        <button
          onClick={() => {
            stop();
            navigate('/admin/orgs');
          }}
          className="bg-white/20 hover:bg-white/30 text-white text-xs font-semibold px-3 py-1 rounded-lg transition-colors"
        >
          יציאה
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
